import { Box, Divider, Typography } from "@mui/material";
import { React, useState } from "react";
import AppButton from "../../../../../base/AppButton.component";
import { CheckCircle } from "@mui/icons-material";
import { useTheme } from "@emotion/react";
const DeactivateDialog = ({
  deactivateHandler,
  dealership,
  activateHandler,
}) => {
  const [actionSuccess, setActionSuccess] = useState(false);
  const theme = useTheme();

  const toggleDealershipStatus = () => {
    if (!dealership?.is_active) {
      activateHandler();
    } else {
      deactivateHandler();
    }
    setActionSuccess(true);
  };

  return (
    <>
      <Divider sx={{ marginBottom: "24px" }} />
      <Typography
        variant="h6"
        sx={{ display: "flex", justifyContent: "center" }}
      >
        {`Are you sure you want to ${
          dealership?.is_active ? "Deactivate" : "Activate"
        } Dealership?`}
      </Typography>
      <Divider sx={{ marginBottom: "24px", marginTop: "24px" }} />
      {actionSuccess ? (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CheckCircle color={"primary"} />
          <span
            style={{ color: theme.palette.primary.main, marginLeft: "4px" }}
          >
            SUCCESS
          </span>
        </Box>
      ) : (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <AppButton
            sx={{ width: "200px", alignItems: "center" }}
            buttonText={
              dealership?.is_active
                ? "Deactivate Dealership"
                : "Activate Dealership"
            }
            clickHandler={toggleDealershipStatus}
          />
        </Box>
      )}
    </>
  );
};

export default DeactivateDialog;
